exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-page .table-wrap[data-v-1192e6ba] {\n  margin-top: 20px;\n}\n.upload-page .preview-wrap[data-v-1192e6ba] {\n  max-height: 600px;\n  overflow-y: auto;\n}\n.upload-page .preview-dom[data-v-1192e6ba] {\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1192e6ba","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/uploadImage/dragUpload.vue
// module id = 1132
// module chunks = 7